export default "__VITE_ASSET__D2V79KJp__"